var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInteractions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31.298,
    viewBox: "328 600.351 30 31.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "repeat-2-line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337 628v2.898a.75.75 0 0 1-1.23.577l-6.18-5.149a.75.75 0 0 1 .483-1.326H352a3 3 0 0 0 3-3v-12h3v12a6 6 0 0 1-6 6h-15Zm12-24v-2.898a.75.75 0 0 1 1.23-.578l6.18 5.15a.75.75 0 0 1-.482 1.326H334a3 3 0 0 0-3 3v12h-3v-12a6 6 0 0 1 6-6h15Z",
    fill: "#541690",
    fillRule: "evenodd",
    "data-name": "Path 290"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractions);
export default __webpack_public_path__ + "static/media/interactions.352f2d13.svg";
export { ForwardRef as ReactComponent };